"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.establishSession = establishSession;
async function establishSession(params) {
    const request = {
        header: this.header,
        ...params,
    };
    request.integrationPartnerId = this.initializationParams.integrationPartnerId;
    request.currency = 'GBP';
    request.language = 'en';
    request.granularChannelType = 5;
    request.channelInformation = 'GEP-exchange-D~Windows~Browser-1.3142|';
    request.initialLanguage = 'en';
    request.numberLogonAttemptsToReturn = 3;
    await this.sendRequest('establishSession.ashx', request).then((data) => {
        this.sessionToken = data.sessionToken;
        this.userContext = {
            partnerUsername: request.partnerUsername || '',
            punterId: data.punterId,
            punterClassificationName: data.punterClassificationName,
            debitSportsbookStake: data.debitSportsbookStake,
            debitExchangeStake: data.debitExchangeStake,
            canDeposit: data.canDeposit,
            canPlaceAgainstSideOrders: data.canPlaceAgainstSideOrders,
            canPlaceForSideOrders: data.canPlaceForSideOrders,
            canPlaceOrders: data.canPlaceOrders,
            canWithdraw: data.canWithdraw,
            purseIntegrationMode: data.purseIntegrationMode,
            cohort: data.cohort,
            restrictedToFillKillOrders: data.restrictedToFillKillOrders,
            hasSubPunters: data.hasSubPunters,
            marketByVolumeAmount: data.marketByVolumeAmount,
            integrationPartnerId: data.integrationPartnerId,
            aDWPointsEarned: data.aDWPointsEarned,
            isOnLegacyRegime: data.isOnLegacyRegime,
            whiteLabel: data.whiteLabel,
            isIdentityEstablished: data.isIdentityEstablished,
            isASubPunter: data.isASubPunter,
            language: data.language,
            currency: data.currency,
            priceFormat: data.priceFormat,
            returnCode: data.returnCode,
            errorInformation: '',
        };
    });
    return this.userContext;
}
